import Helper from './Helper';

class BackToTop {
  constructor(config = {}){
  const {
    buttonClass,
    stickyClass,
    fadeInPosition,
    correction
   } = config

    this.pos = fadeInPosition || 500;

    const toggle = document.querySelector(buttonClass);

    if(toggle){
      toggle.addEventListener('click', e => {
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
      
      const stopElement = document.querySelector(stickyClass);
      this.stickyPosition =  Helper.getOffsetTop(stopElement) - window.innerHeight + correction;
      
      this.checkPosition(toggle);
      window.addEventListener('scroll', () => {
        this.checkPosition(toggle);
      });
    }
  }

  checkPosition(toggle){
    if(window.pageYOffset > this.pos){
      if(!toggle.classList.contains('visible')) toggle.classList.add('visible');
    } else {
      if(toggle.classList.contains('visible')) toggle.classList.remove('visible');
    }
    
    if(window.pageYOffset > this.stickyPosition){
      if(!toggle.classList.contains('sticky')) toggle.classList.add('sticky');
    } else {
      if(toggle.classList.contains('sticky')) toggle.classList.remove('sticky');
    }
  }

} export default BackToTop;
